import { ILeanButtonProps as IButtonPropsBase, LeanButtonBase } from "./LeanButtonBase";

export type ButtonMode = "primary" | "secondary" | "ghost" | "primaryAlt" | "link";

export interface IButtonProps extends IButtonPropsBase, React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const LeanButton: React.FC<IButtonProps> = ({
  text,
  mode,
  icon,
  iconLeft,
  iconRight,
  className,
  ...buttonElementAttributes
}) => {
  return (
    <>
      <LeanButtonBase
        text={text}
        mode={mode}
        icon={icon}
        iconLeft={iconLeft}
        iconRight={iconRight}
        className={className}
        render={(cn, children) => (
          <button {...buttonElementAttributes} className={cn}>
            {children}
          </button>
        )}
      />
    </>
  );
};
